// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabsContainer__Hy33A {
  position: absolute;
  top: 25px;
  left: 25px;
  width: 220px;
  height: 100%;
}
@media (max-width: 1024px) {
  .tabsContainer__Hy33A.tabsContainerPosition__P8p53 {
    height: 300px;
  }
}

.globalMapButton__QcKlZ {
  margin: 0 0 15px 24px;
}

.tabsScrollbars__EsyIj {
  max-height: 330px;
  overflow-y: auto;
}
.tabsScrollbars__EsyIj::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.tabsScrollbars__EsyIj::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.tabsScrollbars__EsyIj::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.tabsScrollbars__EsyIj::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 1280px) {
  .tabsScrollbars__EsyIj::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.05);
  }
  .tabsScrollbars__EsyIj::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.02);
  }
}

.tabContainer__SpSR9 {
  margin-bottom: 10px;
}

.arrow__I7xaO {
  stroke: var(--tables-primary-row-text-main);
  transform: rotate(-90deg);
  transition: transform 0.5s;
  cursor: pointer;
}

.arrowActive__eMjfE {
  transform: rotate(0);
}

.tab__rLciv {
  margin-left: 10px;
  cursor: pointer;
  color: var(--tables-primary-row-text-main);
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 12px;
  text-transform: uppercase;
}

.facilityItem__TUGV_ {
  display: block;
  cursor: pointer;
  text-decoration: none;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--tables-primary-row-text-main);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.11px;
}
@media (max-width: 1280px) {
  .facilityItem__TUGV_ {
    font-size: 12px;
  }
}

.mapTabsTooltip__DBU80 {
  padding: 8px !important;
  opacity: 1 !important;
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
  border-radius: 4px !important;
  text-align: left !important;
}

.facilityItemsContainer__DmTrZ {
  margin: 0;
  padding: 0 0 0 24px;
  list-style: none;
}

.facilityItemContainer__taZtz {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 15px;
  padding-right: 12px;
}
@media (max-width: 1280px) {
  .facilityItemContainer__taZtz {
    margin-top: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/components/common/Maps/components/MapTabs/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;AAzEF;AA4EI;EADF;IAEI,aAAA;EAzEJ;AACF;;AA6EA;EACE,qBAAA;AA1EF;;AA6EA;EACE,iBAAA;EACA,gBAAA;AA1EF;AAME;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAJJ;AAOE;EACE,+BAAA;EACA,kBAAA;AALJ;AAQE;EACE,8BAAA;EACA,kBAAA;AANJ;AASE;EACE,gBAAA;EACA,kBAAA;AAPJ;AA4DE;EACE;IACE,+BAAA;EA1DJ;EA6DE;IACE,+BAAA;EA3DJ;AACF;;AA+DA;EACE,mBAAA;AA5DF;;AA+DA;EACE,2CAAA;EACA,yBAAA;EACA,0BAAA;EACA,eAAA;AA5DF;;AA+DA;EACE,oBAAA;AA5DF;;AA+DA;EACE,iBAAA;EACA,eAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA5DF;;AA+DA;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AA5DF;AA8DE;EAdF;IAeI,eAAA;EA3DF;AACF;;AA8DA;EA/FE,uBAAA;EACA,qBAAA;EACA,mDAAA;EACA,6BAAA;EACA,2BAAA;AAqCF;;AA0DA;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;AAvDF;;AA0DA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAvDF;AAyDE;EAPF;IAQI,gBAAA;EAtDF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.tabsContainer {\n  position: absolute;\n  top: 25px;\n  left: 25px;\n  width: 220px;\n  height: 100%;\n\n  &.tabsContainerPosition {\n    @media (max-width: 1024px) {\n      height: 300px;\n    }\n  }\n}\n\n.globalMapButton {\n  margin: 0 0 15px 24px;\n}\n\n.tabsScrollbars {\n  max-height: 330px;\n  overflow-y: auto;\n  @include scrollBar;\n\n  @media (max-width: 1280px) {\n    &::-webkit-scrollbar-thumb {\n      background: rgba(0, 0, 0, 0.05);\n    }\n\n    &::-webkit-scrollbar-track {\n      background: rgba(0, 0, 0, 0.02);\n    }\n  }\n}\n\n.tabContainer {\n  margin-bottom: 10px;\n}\n\n.arrow {\n  stroke: var(--tables-primary-row-text-main);\n  transform: rotate(-90deg);\n  transition: transform 0.5s;\n  cursor: pointer;\n}\n\n.arrowActive {\n  transform: rotate(0);\n}\n\n.tab {\n  margin-left: 10px;\n  cursor: pointer;\n  color: var(--tables-primary-row-text-main);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 12px;\n  text-transform: uppercase;\n}\n\n.facilityItem {\n  display: block;\n  cursor: pointer;\n  text-decoration: none;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: var(--tables-primary-row-text-main);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  letter-spacing: 0.11px;\n\n  @media (max-width: 1280px) {\n    font-size: 12px;\n  }\n}\n\n.mapTabsTooltip {\n  @include tooltip;\n}\n\n.facilityItemsContainer {\n  margin: 0;\n  padding: 0 0 0 24px;\n  list-style: none;\n}\n\n.facilityItemContainer {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-top: 15px;\n  padding-right: 12px;\n\n  @media (max-width: 1280px) {\n    margin-top: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabsContainer": `tabsContainer__Hy33A`,
	"tabsContainerPosition": `tabsContainerPosition__P8p53`,
	"globalMapButton": `globalMapButton__QcKlZ`,
	"tabsScrollbars": `tabsScrollbars__EsyIj`,
	"tabContainer": `tabContainer__SpSR9`,
	"arrow": `arrow__I7xaO`,
	"arrowActive": `arrowActive__eMjfE`,
	"tab": `tab__rLciv`,
	"facilityItem": `facilityItem__TUGV_`,
	"mapTabsTooltip": `mapTabsTooltip__DBU80`,
	"facilityItemsContainer": `facilityItemsContainer__DmTrZ`,
	"facilityItemContainer": `facilityItemContainer__taZtz`
};
module.exports = ___CSS_LOADER_EXPORT___;
